<template>
  <div class="navbar" v-if="show" :style="HarmonyStatusBarStyleCpd">
    <div class="cms-client-header" :style="HarmonyHeaderStyleCpd">
      <p class="header-back" @click="clickHandle">
        <img :src="`${baseUrl}static/imgs/back.png`" />
      </p>
      <p class="header-title">{{title}}</p>
      <!-- TODO：鸿蒙系统暂时隐藏分享 -->
      <div v-if="shareInfo.isShowShareIcon && !isQunarHarmony && !isTujiaHarmony" class="iconfont icon-share share-icon" @click="shareClickHandler"></div>
    </div>
  </div>
</template>

<script>
import { Sniff } from '@/utils/q_sniff'
import tujialogin from '@/utils/tujialogin.js'
import { loginQ } from '@/utils/q_userinfo'
import { TCShare, QShare } from '@/components/sharePopup'
import { base64Encode } from '@/utils/base64'
export default {
  mixins: [tujialogin],
  async mounted() {
    const { isTujiaAppEnv, isMayiAppEnv, isCtripAppEnv, isQunarAppEnv } = this.platformEnv
    if (isTujiaAppEnv || isMayiAppEnv) {
      setTimeout(async() => {
        window.bridge && window.bridge.enableNavigationBar(false)
      }, 100)
      window.addEventListener('pageshow', this._onPageShow = () => {
        try {
          window.bridge.enableNavigationBar(false)
        } catch (error) {
        }
      })
    }
    if (isCtripAppEnv) {
      window.CtripBar && window.CtripBar.app_set_navbar_hidden(false)
      window.CtripBar && window.CtripBar.app_refresh_nav_bar(
        JSON.stringify({
          center: [{ tagname: 'title', value: this.title }],
          right: [{ tagname: 'share' }]
        }),
        () => {
          console.log('app_refresh_nav_bar: success')
        }
      )
      if (!window.app) {
        window.app = {}
      }
      window.app.callback = async(cbJson) => {
        if (cbJson?.tagname === 'share') {
          await this.shareClickHandler()
        } else if (cbJson?.tagname === 'back') {
          this.backClickHandler()
        }
      }
    }
    if (isQunarAppEnv) {
      window._fas && window._fas.setCustomTrack({
        eventname: 'C_HOME_CMS_SET_NAV_DISPLAY_STATUS',
        ext: {
          rank_list_id: this.$root.promotionId,
          rank_list_name: this.$root.htmlTitle,
          setNavDisplayStatus: window.hysdk?.setNavDisplayStatus
        }
      })
      // 鸿蒙自己适配头部
      window.hysdk && window.hysdk?.setNavDisplayStatus && window.hysdk.setNavDisplayStatus({ action: Sniff.isHarmonyWithoutAdr ? 'hide' : 'show' })
      const hysdk = window.hysdk
      hysdk && hysdk.ready((env) => {
        if (env === 'hy') {
          hysdk.navRefresh({
            title: {
              style: 'text',
              text: this.title
            },
            right: {
              style: 'icon',
              icon: '\uf0cc'
            }
          })
          hysdk.onNavClick({
            success: (data) => {
              switch (data.button) {
              case 'right':
                this.qunarShare()
                break
              case 'default':;
              }
            }
          })
        }
      })
    }
  },
  computed: {
    isActiveFission() {
      return ['T20230310142815', 'T20230310191107', 'Q20230310140905'].indexOf(this.$route.query.id) > -1
    },
    HarmonyStatusBarStyleCpd() {
      if (this.isQunarHarmony) {
        return `height: ${40 + Sniff.immersiveOffset || 0}px`
      } else if (this.isTujiaHarmony) {
        return `height: ${40 + this.tujiaHarmonyStatusBarHeight || 0}px`
      } else {
        return ''
      }
    },
    HarmonyHeaderStyleCpd() {
      if (this.isQunarHarmony) {
        return `padding-top: ${Sniff.immersiveOffset || 0}px`
      } else if (this.isTujiaHarmony) {
        return `padding-top: ${this.tujiaHarmonyStatusBarHeight || 0}px`
      } else {
        return ''
      }
    }
  },
  data() {
    const { isTujiaAppEnv, isMayiAppEnv } = this.platformEnv
    return {
      show: isTujiaAppEnv || isMayiAppEnv || Sniff.isHarmonyWithoutAdr,
      // T端分享弹层
      popOptions: {
        visible: false
      },
      // 生成分享图弹层
      popOptionsImg: {
        visible: false
      },
      showCode: true,
      // 当前页面海报base64
      imgBase64: '',
      // 当前页面海报url
      shareCirleUrlImg: '',
      // 海报状态:0,默认生成图片中 1,生成失败 2,上传成功
      showType: 0,
      // 分享的模版
      shareModelChoosed: [
        {
          type: 'wrap',
          width: 750,
          height: 1334
        },
        {
          // banner背景
          type: 'image',
          url: '',
          x: 0,
          y: 0,
          width: 750,
          height: 1334
        },
        {
          // 7二维码
          type: 'image',
          url: '',
          x: 467,
          y: 1045,
          width: 220,
          height: 220
        }
      ],
      isQunarHarmony: !!Sniff.isHarmonyWithoutAdr
    }
  },
  watch: {
    title(newVal) {
      if (newVal) {
        if (this.platformEnv.isCtripAppEnv) {
          window.CtripBar.app_refresh_nav_bar(
            JSON.stringify({
              center: [{ tagname: 'title', value: newVal }],
              right: [{ tagname: 'share' }]
            }),
            () => {
              console.log('app_refresh_nav_bar: success')
            }
          )
        }
        if (this.platformEnv.isQunarAppEnv) {
          window.hysdk.navRefresh({
            title: {
              style: 'text',
              text: this.title
            },
            right: {
              style: 'icon',
              icon: '\uf0cc'
            }
          })
        }
      }
    }
  },
  props: {
    title: {
      type: String,
      default: function() {
        return ''
      }
    },
    shareInfo: {
      type: Object,
      default: function() {
        return {}
      }
    },
    isTujiaHarmony: {
      type: Boolean,
      default: false
    },
    houseInfo: {// 根据地址栏房屋 id 获取房屋信息
      type: Object
    },
    goToCtripListPage: {// 携程落地页，点击导航栏返回按钮的时候直接跳转携程L页面
      type: Boolean,
      default: false
    },
    tujiaHarmonyStatusBarHeight: {
      type: Number,
      default: 0
    }
  },
  methods: {
    /**
     * @description:在携程环境中且要求返回的时候跳转携程L页面
     * **/
    backClickHandler() {
      // 判断是否需要跳转到携程列表页
      if (this.goToCtripListPage) {
        const SPECIAL_ID = 'T20250704144806'
        const isSpecialCase = this.$route.query.id === SPECIAL_ID
        if (isSpecialCase) {
          // 要求识别到这个活动id时，写死跳转链接
          const SPECIAL_URL = `ctrip://wireless/h5?type=5&url=L3JuX2JuYi9tYWluLmpzP0NSTk1vZHVsZU5hbWU9VHVKaWFBcHAmQ1JOVHlwZT0xJmluaXRpYWxQYWdlPVNlYXJjaExpc3Qmb3ZlcnNlYT0xJmhvbWVwYWdlPTEmaG9tZUtleXdvcmQ9MCZpZD0xMjc0OTgyJmNpdHlOYW1lPSVFNSVBNCVBNyVFOSU5OCVBQQ==`
          window.location.href = SPECIAL_URL
          return false
        }
        // 默认跳转到日本大阪的L页，ID为1274982
        let id = 1274982
        // 从路由参数中获取cityId
        const { cityId } = this.$route.query
        // 如果路由参数中有cityId，则使用该值
        // eslint-disable-next-line brace-style
        if (cityId) { id = cityId }
        // 如果路由参数中没有cityId，则尝试从房屋信息中获取
        else if (this.houseInfo.cityId) {
          id = this.houseInfo.cityId
        }
        // 如果有有效的ID
        if (id) {
          // 构建携程RN页面的URL并进行base64编码
          const url = base64Encode(`/rn_bnb/_bnb_crn_config?CRNModuleName=TuJiaApp&CRNType=1&id=${id}&initialPage=SearchList&url=https%3A%2F%2Fm.tujia.com%2Fgongyu%2Fbeijing%2F`)
          // 跳转到携程APP的H5页面
          window.location.href = `ctrip://wireless/h5?type=5&url=${url}`
        }
      }
    },
    /**
     * 分享按钮点击
     */
    async shareClickHandler() {
      if (this.$root.isForceLogin && process.env.VUE_APP_LOCAL !== 'Q' && !(await this.isLogin())) {
        const { autoGetRedpacketId, fId } = this.$route.query
        const redirect = `${window.location.href}${autoGetRedpacketId ? '&autoGetRedpacketId=' + autoGetRedpacketId : ''}${fId ? '&fId=' + fId : ''}`
        this.goLoginPage({ redirect })
      } else {
        TCShare()
        window._fas && window._fas.setCustomTrack({
          eventname: 'C_HOME_CMS_SHARE_CLICK',
          ext: {
            rank_list_id: this.$root.promotionId,
            rank_list_name: this.$root.htmlTitle
          }
        })
      }
    },
    qunarShare() {
      // 强登录-Q未登录时，不调起分享
      if (this.$root.isForceLogin && !Sniff.isLogin) {
        loginQ()
      } else {
        QShare()
        window._fas && window._fas.setCustomTrack({
          eventname: 'C_HOME_CMS_SHARE_CLICK',
          ext: {
            rank_list_id: this.$root.promotionId,
            rank_list_name: this.$root.htmlTitle
          }
        })
      }
    },
    clickHandle() {
      const { isTujiaAppEnv, isMayiAppEnv, isCtripAppEnv, isQunarAppEnv } = this.platformEnv
      const prevPage = window.location.href
      window.history.go(-1)
      this.clearTime = setTimeout(() => {
        if (window.location.href === prevPage) {
          if (isTujiaAppEnv || isMayiAppEnv) {
            window.tjBridge && window.tjBridge.popWebView({})
          }
          if (isCtripAppEnv) {
            window.CtripUtil.app_back_to_last_page()
          }
          if (isQunarAppEnv) {
            window.hysdk.closeWebView()
          }
        }
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 40px;
  .placeholder {
  }
}
.cms-client-header {
  position: fixed;
  top: 0;
  z-index: 10;
  width: 100%;
  box-sizing: content-box;
  font-size: 0;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}
.header-back {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  left: 0;
  bottom: 0;
  height: 40px;
  width: 40px;
  margin-left: 20px;
  z-index: 999;
  img {
    width: 10px;
    height: 18px;
  }
}
.header-title {
  font-size: 18px;
  text-align: center;
  flex: 1;
  color: #333;
  letter-spacing: 0;
  margin: 0;
}
.share-icon {
  position: absolute;
  right: 15px;
  font-size: 28px;
  color: #999;
}
</style>
